import React from 'react'
import { Tooltip } from 'antd'

interface TextWithTooltipProps {
  text: string
  maxLength?: number
  className?: string
  placement?: 'top' | 'bottom' | 'left' | 'right'
}

const TextWithTooltip: React.FC<TextWithTooltipProps> = ({
  text,
  maxLength = 60,
  className = '',
  placement = 'top'
}) => {
  const isClipped = text.length > maxLength

  const displayText = isClipped ? text.slice(0, maxLength).trim() + '...' : text

  const paragraph = <p className={`${className} m-0`}>{displayText}</p>

  if (!isClipped) return paragraph

  return (
    <Tooltip title={text} placement={placement}>
      {paragraph}
    </Tooltip>
  )
}

export default TextWithTooltip
